// BoostModal.js
import React from 'react';
import './BoostModal.css';

const BoostModal = ({ onClose, onSelect }) => {
  const options = [
    { days: 1, price: 1 },
    { days: 7, price: 7 },
    { days: 15, price: 15 },
    { days: 30, price: 30 },
  ];

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h3>Elanı irəli çəkmə</h3>
        <p>Seçim edin:</p>
        <div className="options">
          {options.map((option) => (
            <button
              key={option.days}
              className="option-btn"
              onClick={() => onSelect(option)}
            >
              {option.days} gün - {option.price} AZN
            </button>
          ))}
        </div>
        <button className="close-btn" onClick={onClose}>Bağla</button>
      </div>
    </div>
  );
};

export default BoostModal;
